import { GET } from './httpMethods';

const getConfigUnleash = async () => {
    const { configUnleash } = await GET('/api/conf-unleash').then((response) => response.json());

    return configUnleash;
};

export default getConfigUnleash;
